import React from 'react';

/**
 * Body Condition Heading component
 */
const BodyConditionHeadingOutput = (props) => (
  <div className="nppe2-fc-body-condition-heading">
    <h2>{props.data.labelMain}</h2>
    <hr/>
  </div>
);

export default BodyConditionHeadingOutput;
